export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9313.9baaab1e.jpg";